import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
import e from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, a, m, p, h, f) {
  return o(), l("svg", n, a[0] || (a[0] = [
    t("path", {
      fill: "currentColor",
      d: "M12.505 1.195a.75.75 0 0 1 .743.648l.007.102v.962a.75.75 0 0 1-1.494.102l-.006-.102v-.962a.75.75 0 0 1 .75-.75Zm5.993 2.26a.75.75 0 0 1 1.138.97l-.072.085-.953.962a.75.75 0 0 1-1.138-.97l.072-.085.953-.963ZM4.442 3.448a.75.75 0 0 1 .977-.068l.084.073.953.963a.75.75 0 0 1-.983 1.128l-.083-.073-.953-.962a.75.75 0 0 1 .005-1.061Zm17.614 7.394a.75.75 0 0 1 .102 1.493l-.102.007h-.953a.75.75 0 0 1-.101-1.493l.101-.007h.953Zm-19.158 0a.75.75 0 0 1 .101 1.493l-.101.007h-.953a.75.75 0 0 1-.102-1.493l.102-.007h.953Zm8.869-4.583.215.001c3.058-.076 5.608 2.303 5.8 5.371l.01.22v4.595a1.757 1.757 0 0 1 1.562 1.18l.355 1.018a1.78 1.78 0 0 1-.22 1.604c-.328.47-.863.751-1.435.751H5.947a1.75 1.75 0 0 1-1.414-.722 1.78 1.78 0 0 1-.264-1.564l.31-1.019a1.757 1.757 0 0 1 1.678-1.25l-.049.001.001-4.613c.079-3.08 2.56-5.533 5.558-5.573Zm5.931 11.685H6.257a.257.257 0 0 0-.243.186l-.31 1.019a.28.28 0 0 0 .04.245.251.251 0 0 0 .203.105h12.107c.08 0 .157-.04.205-.11a.28.28 0 0 0 .034-.25l-.355-1.02a.256.256 0 0 0-.24-.175ZM12.193 7.76h-.42C9.638 7.814 7.88 9.5 7.72 11.644l-.01.208-.001 4.592h8.584v-4.572a4.203 4.203 0 0 0-4.099-4.111Z"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ e(r, [["render", c]]);
export {
  _ as default
};
